<section class="config-panel doa-range-panel">
  <div class="panel-header refine-header">
    <div class="refine-title">
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <path d="M12 20h9"></path>
        <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"></path>
      </svg>
      <span class="ph-title">DOA - Range Level - New/Edit</span>
    </div>
    <div class="record-chip">
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <ellipse cx="12" cy="5" rx="9" ry="3"></ellipse>
        <path d="M21 12c0 1.7-4 3-9 3s-9-1.3-9-3"></path>
        <path d="M3 5v14c0 1.7 4 3 9 3s9-1.3 9-3V5"></path>
      </svg>
      {{ recordCount }} records
    </div>
  </div>

  <div class="panel-body">
    <div class="form-row doa-range-row">
      <div class="form-group">
        <label class="doa-label">Business Unit <span class="doa-req">*</span></label>
        <select class="custom-input doa-select" [(ngModel)]="form.businessUnit">
          <option value="" disabled>Select</option>
          <option *ngFor="let bu of businessUnitOptions" [value]="bu">{{ bu }}</option>
        </select>
      </div>

      <div class="form-group doa-group-range">
        <label class="doa-label">Range <span class="doa-req">*</span></label>
        <div class="doa-radio-row">
          <label class="doa-radio-option">
            <input type="radio" name="doaRangeType" value="existing" [(ngModel)]="form.rangeType" />
            <span>Existing</span>
          </label>
          <label class="doa-radio-option">
            <input type="radio" name="doaRangeType" value="new" [(ngModel)]="form.rangeType" />
            <span>New Range</span>
          </label>
        </div>
      </div>

      <div class="form-group doa-group-sm">
        <label class="doa-label">Range Level</label>
        <select class="custom-input doa-select" [(ngModel)]="form.rangeLevel">
          <option *ngFor="let lvl of rangeLevelOptions" [ngValue]="lvl">{{ lvl }}</option>
        </select>
      </div>

      <div class="form-group doa-group-sm">
        <label class="doa-label">Range 1 <span class="doa-req">*</span></label>
        <input type="text" class="custom-input doa-text" [(ngModel)]="form.range1" />
      </div>

      <div class="form-group doa-group-sm">
        <label class="doa-label">Range 2 <span class="doa-req">*</span></label>
        <input type="text" class="custom-input doa-text" [(ngModel)]="form.range2" />
      </div>

      <div class="form-group doa-group-action">
        <div class="doa-action-btns">
          <button
            type="button"
            class="btn-doa-save btn-doa-tick"
            [disabled]="!canSave"
            (click)="submit()"
            title="Add to pending changes"
            aria-label="Add to pending changes"
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round">
              <path d="M20 6 9 17l-5-5"></path>
            </svg>
          </button>
          <button
            type="button"
            class="btn-doa-reset"
            (click)="resetForm()"
            title="Reset form"
            aria-label="Reset form"
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <path d="M3 4h10.5M3 4l7 8v7l4-2v-5l1.2-1.4"></path>
              <circle cx="18" cy="6" r="4.5"></circle>
              <path d="m16.5 4.5 3 3m0-3-3 3"></path>
            </svg>
          </button>
        </div>
      </div>
    </div>
  </div>
</section>
